import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactSlider from 'rc-slider'
import './VolumeControl.scss'

export default class VolumeControl extends Component {
  static propTypes = {
    setVolume: PropTypes.func.isRequired,
    initialVolume: PropTypes.number.isRequired
  }

  state = {
    volume: undefined,
    muted: false,
    displayVolumeBar: false
  }

  componentDidMount() {
    this.setState({
      volume: this.props.initialVolume
    })
  }

  _handleSetVolume = newVolume => {
    this.setVolume(newVolume)
    this.setState({muted: false})
  }

  setVolume = (newVolume) => {
    this.props.setVolume(newVolume)
    this.setState({volume: newVolume})
  }

  get actualVolume() {
    const {volume, muted} = this.state
    return muted ? 0 : volume
  }

  toggleMute = (e) => {
    const {volume, muted} = this.state
    if (muted || volume === 0) {
      this.setVolume(volume || 1)
      this.setState({muted: false})
    } else {
      this.props.setVolume(0)
      this.setState({muted: true})
    }
  }

  handleClick = (e) => {
    const {displayVolumeBar} = this.state
    if (e.fastclick && !displayVolumeBar) {
      return
    }

    this.toggleMute()
  }

  showVolumeBar = () => this.setState({displayVolumeBar: true})
  hideVolumeBar = () => this.setState({displayVolumeBar: false})

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      this.handleClick(e)
    }
  }

  render() {
    const {displayVolumeBar} = this.state
    const {actualVolume, handleClick, showVolumeBar, hideVolumeBar} = this
    const volumeType = actualVolume ? 'volume-button' : 'muted'

    return (
      <div styleName="volume-controls" onMouseEnter={showVolumeBar} onMouseLeave={hideVolumeBar}>
        <div
          styleName={volumeType}
          data-id="preview-volume-button"
          data-bi-target="preview-volume-button"
          data-bi-is-muted={volumeType}
          onClick={handleClick}
          tabIndex={0}
          onKeyDown={this.handleKeyDown}
          role="button"
          aria-label="Volume control"
          onFocus={showVolumeBar}
          onBlur={hideVolumeBar}
        />
        {displayVolumeBar && (
          <div styleName="volume-slider-container">
            <ReactSlider
              styleName="volume-slider"
              tipFormatter={null}
              value={actualVolume}
              onChange={this._handleSetVolume}
              min={0}
              max={1}
              step={0.01}
              vertical={true}
              tabIndex={-1}
            />
          </div>
        )}
      </div>
    )
  }
}
